import { selectItemById } from 'app/redux/store/features/payments'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import { IconButton, Typography } from '@mui/material'
import { getPaymentById } from 'app/redux/store/features/payments'
import PaymentsViewForm from './PaymentsViewForm'
import utilServices from 'app/services/util-services'
import WestIcon from '@mui/icons-material/West'
import Stack from '@mui/material/Stack'

const PaymentsView = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { state } = useLocation()
    const { id } = state
    const { payments, loading, error } = useSelector((state) => state.payments)
    const payment = selectItemById(payments, id)
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
    }, [loading])

    useEffect(() => {
        if (utilServices.isNullOrUndefined(payment.id)) dispatch(getPaymentById({ id: id }))
    }, [])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    return (
        <React.Fragment>
            <JumboCardQuick
                title={
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <IconButton
                            className='backArrowForm'
                            onClick={() =>
                                navigate(`/registrations/payments`, {
                                    state: { navigateFrom: 'cancel-detail-payments' },
                                })
                            }>
                            <WestIcon />
                        </IconButton>
                        <Typography color={'common.white'} variant={'h3'} sx={{ mt: 0.8 }}>
                            Payment Details
                        </Typography>
                    </Stack>
                }
                headerSx={{
                    height: 40,
                    bgcolor: 'primary.main',
                }}>
                <PaymentsViewForm payment={payment} />
            </JumboCardQuick>
        </React.Fragment>
    )
}

export default PaymentsView
